import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import GrillaVacia from '../../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { Autocomplete, Box, CircularProgress, InputAdornment, TextField } from '@mui/material';
import { useDebounce } from '../../../../hooks/useDebounce';

import { GET_INSUMOS } from '../../../../data/graphQL/queries/ResumenIngreso/getAllInsumos';
import { adaptInsumosArray } from '../../../../adapters/resumenIngreso/insumosAdapter';
import SearchIcon from '@mui/icons-material/Search';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { GET_INDICACIONES_BY_PANTALLA } from '../../../../data/graphQL/queries/ResumenIngreso/getIndicacionesRIByPantalla';
import { CREATE_INDICACION } from '../../../../data/graphQL/mutations/ResumenIngreso/CreateIndicacionRI';
import toast, { Toaster } from 'react-hot-toast';
import { REMOVE_INDICACION } from '../../../../data/graphQL/mutations/ResumenIngreso/removeIndicacionRI';
import { adaptIndicacionesArray } from '../../../../adapters/resumenIngreso/indicacionesAdapter';

export const IndicacionInput = ({ idPantallaRI, idDatosGeneralesRI, setChildrenAction, edit, setTieneIndicaciones }) => {

  const columns = generateColumnsDefaultConfiguration([
    {
      field: 'action',
      headerName: '',
      flex: 3,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <DeleteOutlineIcon className='edit-icon' onClick={() => edit ? deleteIndicacion(row) : null} />);

      }
    },
    {
      headerName: 'Producto',
      field: 'nombreInsumo',
      flex: 57
    },
    {
      headerName: 'Cant. Diaria',
      field: 'cantidadDiaria',
      flex: 25

    },
    {
      headerName: 'Unidad',
      field: 'unidad',
      flex: 20
    }]
  );

  const [indicaciones, setIndicaciones] = useState([]);

  const [openformModal, setOpenformModal] = useState(false);
  const [productoSelected, setProductoSelected] = useState({});
  const [cantidadDiaria, setCantidadDiaria] = useState();

  const [
    insumos,
    filterStatus,
    insumosLoading,
    setFilterStatus] =
    useGetInsumos(idDatosGeneralesRI);

  const { refetch: refetchIndicaciones, data: indicacionesData } = useQuery(GET_INDICACIONES_BY_PANTALLA, {
    fetchPolicy: 'no-cache',
    variables: { idPantallaRI, idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!indicacionesData) return;

    setIndicaciones(adaptIndicacionesArray(indicacionesData));
  }, [indicacionesData]);

  const [createIndicacion] = useMutation(CREATE_INDICACION);
  const [removeIndicacion] = useMutation(REMOVE_INDICACION);

  useEffect(() => {
    setTieneIndicaciones(!!indicaciones.length);
  }, [indicaciones]);

  useEffect(() => {
    if (!indicaciones.length) return setChildrenAction(null);

    setChildrenAction(() =>
      <CustomButton
        onClick={handleOpenFormModal}
        disabled={!edit}
        size='small'
        variant='outlined'>

        Agregar
      </CustomButton>
    );

  }, [indicaciones]);

  const deleteIndicacion = async (indicacion) => {
    try {
      await removeIndicacion({
        variables: {
          idIndicacionRI: indicacion?.idIndicacionRI
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesArray(indicacionesData));
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenFormModal = () => setOpenformModal(true);

  const handleCloseFormModal = () => {
    setOpenformModal(false);
    setProductoSelected({});
    setCantidadDiaria();
  };

  const handleChange = (value) => {
    setProductoSelected(value);
  };

  const onSubmit = async () => {
    if (!edit) return;
    try {
      await createIndicacion({
        variables: {
          idDatosGeneralesRI,
          idInsumo: productoSelected.id,
          idPantallaRI,
          cantidadDiaria: parseFloat(cantidadDiaria)
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesArray(indicacionesData));
      handleCloseFormModal();
      toast.success('Indicación cargada con éxito');
    } catch (err) {
      toast.error('Ocurrió un error al cargar la indicación');
    }
  };

  return (
    <>

      {!indicaciones?.length && <div className='resumen-ingreso-grilla-vacia'>
        <div className='svg-clientes-grilla-vacia'>
          <img src={GrillaVacia} width='100%'></img>
        </div>
        <label>No se ha agregado ninguna indicación</label>
        <CustomButton
          onClick={handleOpenFormModal}
          size='small'>

          Agregar
        </CustomButton>
      </div>}
      {!!indicaciones.length &&
        <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={columns}
            rows={indicaciones}
            toolbar={false}
            hideFooter />

        </Box>
      }
      <CustomDialog
        maxWidth='md'
        fullWidth
        onCancel={handleCloseFormModal}
        open={openformModal}
        cancelText='Cerrar'
        onAccept={onSubmit}
        acceptDisabled={!productoSelected || !cantidadDiaria}
        acceptText='Agregar'
        title='Indicaciones'>

        <Autocomplete
          options={insumos}
          disableClearable
          noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
          onChange={(_, newValue) => handleChange(newValue)}
          onInputChange={(e) => setFilterStatus(e.target.value)}
          renderOption={(props, option) => {
            return (
              <Box {...props} key={option.id}>
                {option?.label}
              </Box>);

          }}
          renderInput={(params) =>
            <TextField
              {...params}
              sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
              label='Producto'
              margin='none'
              size='small'
              InputProps={{
                ...params.InputProps,
                endAdornment:
                  <InputAdornment position='end'>
                    {insumosLoading ?
                      <CircularProgress color='inherit' size={20} /> :
                      <SearchIcon className='search-icon' />}
                  </InputAdornment>

              }} />
          } />

        <RenderInputByTypeMobile
          grided
          handleChange={(_, value) => setCantidadDiaria(value)}
          input={{
            name: 'cantidadDiaria',
            displayName: 'Cant. diaria',
            type: 'float',
            required: true
          }}
          value={cantidadDiaria} />

        <RenderInputByTypeMobile
          grided
          input={{
            name: 'unidad',
            displayName: 'Unidad',
            type: 'string',
            required: true,
            disabled: true
          }}
          value={productoSelected?.unidad} />

      </CustomDialog>
    </>);

};

const useGetInsumos = (idDatosGeneralesRI) => {

  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: insumosResults }] = useLazyQuery(GET_INSUMOS);

  useEffect(() => {
    if (!insumosResults) return;

    setInsumos(insumosResults);
  }, [insumosResults]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idDatosGenerales: idDatosGeneralesRI,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue]);

  return [
    adaptInsumosArray(insumos) || [],
    filterStatus,
    insumosLoading,
    setFilterStatus];


};